import { html, css, render, LitElement } from "lit-element";

import { ref as litRef } from 'lit/directives/ref.js';
import { styleMap } from "lit-html/directives/style-map.js";

export class Mico extends LitElement {
	file: string;
	svg: any;
	color: string;
	scale: number;
	width: number;
	className: string;
	iconClassName: string;

	static properties = {
		file: { type: String },
		color: { type: String, attribute: "color"  },
		scale: { type: Number, attribute: "scale"  },
		width: { type: Number, attribute: "width" },
		className: { type: String, attribute: "class" },
	};

	createRenderRoot() { return this; }

	async loadSvg() {
		if (!this.file || !this.file.startsWith("svg:")) {
			this.svg = null;
			return;
		}
		const cacheKey = this.file;

		let call = Modelyn.moduleCache.get(cacheKey);
		if (!call) {
			call = Modelyn.getJson('/api/mico?file=' + encodeURIComponent(this.file.substring(4)));
			Modelyn.moduleCache.set(cacheKey, call);
		}
		this.svg = await call;
	}

	async performUpdate() {
		this.iconClassName = this.className;
		this.removeAttribute('class');

		await this.loadSvg();

		super.performUpdate();
	}

	render() {
		if (!this.svg) return html``;

		const styles = {
			"--mico-color": this.color,
			"--mico-scale": this.scale,
			"--mico-stroke-width": this.width,
		};

		return html`<svg class="mico ${this.iconClassName}" viewBox="${this.svg.viewBox}" stroke="${this.svg.stroke}" style=${styleMap(styles)} ${litRef(this.insertSVG)}></svg>`;
	}

	insertSVG = (el?: SVGElement) => {
		el.innerHTML = this.svg.value;
	};
}

